@if (showSizeFilter()) {
  @if (countSizes() > 1) {
    <app-filters-sidebar-filter-checkboxes [label]="label()" [key]="key()"></app-filters-sidebar-filter-checkboxes>
  } @else {
    <app-filters-sidebar-filter [label]="label()">
      <header>Size</header>

      {{size()}}

      <app-link href="lookup">
        <app-icons width="16" icon="pen-to-square"></app-icons>
      </app-link>
    </app-filters-sidebar-filter>
  }
}
